import React from 'react';

const Payment = () => {
    return (
        <div className="pt-3">
            <h2>Payment will be coming soon.</h2>
        </div>
    );
};

export default Payment;